import { useBucket } from '@mc/experiments-react'
import { trackExperimentViewed } from '@mc/track-event'
import { GOOGLE_EMAIL_CAPTURE_FLAG } from '../constants'

export const useExperiment = () => {
  const bucket = useBucket(GOOGLE_EMAIL_CAPTURE_FLAG)

  return {
    isEnabled: bucket?.startsWith('variant'),
    isControl: bucket === 'control',
    isVariant1: bucket === 'variant_1',
    isVariant2: bucket === 'variant_2',
  }
}

export const trackEV = () => trackExperimentViewed(GOOGLE_EMAIL_CAPTURE_FLAG)
